import NodeSpinner from './ui/common/node-spinner'

const Loader = () => {
  return (
    <div className="absolute inset-0 flex items-center justify-center bg-gray-500 bg-opacity-30 rounded-md z-50">
      <NodeSpinner size={40} className="text-primary" />
    </div>
  )
}

export default Loader
